// src/data.jsx

const textContent = `Model,Astex_1,Astex_2,Astex_1_pbvalid,Astex_2_pbvalid,Astex_1_relax,Astex_2_relax,Astex_1_pbvalid_relax,Astex_2_pbvalid_relax,Self_1,Self_2,Self_1_pbvalid,Self_2_pbvalid,Self_1_relax,Self_2_relax,Self_1_pbvalid_relax,Self_2_pbvalid_relax,Cross_1,Cross_2,Cross_1_pbvalid,Cross_2_pbvalid,Cross_1_relax,Cross_2_relax,Cross_1_pbvalid_relax,Cross_2_pbvalid_relax
AlphaFold3,72.941,83.529,67.059,75.294,70.588,82.353,67.059,76.471,43.593,60.585,34.68,45.404,42.201,60.306,38.301,51.811,51.379,68.955,44.179,53.704,48.321,68.671,46.035,62.73
AutoDock Vina,31.765,56.471,30.588,51.765,34.118,56.471,34.118,55.294,23.816,40.111,22.563,36.769,24.373,39.972,23.677,38.301,13.253,28.344,13.095,28.007,15.158,28.929,15.158,28.47
Boltz-1,52.941,69.412,45.882,52.941,50.588,69.412,47.059,57.647,36.212,53.064,25.766,34.401,33.705,53.064,29.248,42.479,41.327,64.762,29.195,42.769,41.039,63.522,35.386,51.279
Boltz-1x,61.176,71.765,60.0,70.588,57.647,72.941,56.471,71.765,36.908,53.9,36.212,52.368,36.072,54.039,34.958,51.95,44.513,63.74,42.659,60.235,44.861,63.603,43.207,59.762
Chai-1,71.765,82.353,64.706,70.588,67.059,82.353,63.529,74.118,40.39,55.989,33.148,43.733,38.858,55.85,35.655,49.582,47.007,66.576,41.624,54.222,45.934,66.385,43.336,59.665
DeepDock,8.235,30.588,5.882,10.588,12.941,34.118,10.588,23.529,4.039,16.156,3.343,6.407,5.85,18.663,5.71,15.042,2.629,17.325,1.029,4.373,6.058,19.573,5.965,15.524
DiffDock,61.176,76.471,50.588,61.176,60.0,76.471,60.0,74.118,15.599,35.794,9.471,16.156,18.663,36.49,18.106,34.68,18.282,46.261,10.404,19.836,22.841,48.507,22.808,47.622
DiffDock-L,77.647,85.882,68.235,72.941,78.824,85.882,78.824,84.706,26.602,46.936,17.409,25.07,30.084,47.354,29.387,44.847,30.159,55.457,19.252,28.144,35.173,55.645,34.173,54.106
DiffDock-Pocket,72.941,83.529,52.941,60.0,72.941,84.706,72.941,83.529,28.273,52.646,18.663,29.109,27.716,52.228,27.298,49.582,33.503,57.491,22.89,33.629,34.719,57.492,34.381,55.71
Discovery Studio,45.882,67.059,45.882,65.882,45.882,67.059,44.706,64.706,37.047,54.735,36.49,54.039,37.047,54.875,35.794,52.646,25.79,44.081,25.331,43.284,25.921,43.683,25.462,42.886
DynamicBind,22.353,62.353,10.588,20.0,29.412,65.882,27.059,58.824,6.964,24.513,3.621,7.799,11.142,26.88,11.142,25.627,11.51,30.488,5.007,9.541,13.385,32.6,13.292,31.83
EquiBind,0.0,10.588,0.0,2.353,0.0,11.765,0.0,9.412,0.0,3.482,0.0,0.418,0.557,4.457,0.557,4.318,0.0,5.114,0.0,0.404,2.027,6.563,2.027,6.563
FABind,18.824,45.882,8.235,9.412,24.706,44.706,20.0,30.588,2.925,15.599,1.253,2.228,6.267,18.802,4.596,12.813,3.701,24.999,1.225,3.994,9.095,29.932,7.492,21.958
Glide,37.647,63.529,37.647,63.529,40.0,64.706,40.0,63.529,31.058,48.329,30.78,47.911,31.894,47.911,31.337,46.24,17.981,37.453,17.522,36.994,19.112,38.436,19.112,38.436
Glide (IFD),28.235,67.059,28.235,67.059,32.941,67.059,32.941,67.059,26.323,46.24,26.184,46.1,25.348,46.518,24.791,45.404,22.444,44.951,22.444,44.951,22.647,44.802,22.647,44.649
GNINA,48.235,81.176,48.235,81.176,47.059,81.176,47.059,81.176,34.958,63.788,33.426,59.471,35.376,64.206,33.983,61.699,24.983,54.037,24.535,51.284,26.82,56.034,26.344,55.035
Interformer,57.647,80.0,45.882,60.0,62.353,83.529,61.176,81.176,30.501,65.042,24.373,48.189,35.097,66.017,34.262,63.37,26.378,59.014,21.522,42.761,31.337,60.642,31.337,60.473
MOE,40.0,56.471,40.0,56.471,40.0,57.647,40.0,57.647,24.095,40.251,23.677,39.554,23.955,39.415,23.259,37.744,15.596,33.282,15.58,33.266,16.083,33.326,16.083,33.173
NeuralPLexer,2.353,28.235,0.0,0.0,12.941,35.294,12.941,30.588,2.786,13.928,0.696,1.393,6.267,17.688,5.571,15.599,4.55,22.141,0.294,1.125,11.089,25.455,10.401,21.863
Protenix,74.118,82.353,62.353,67.059,71.765,81.176,64.706,71.765,41.226,56.685,34.54,44.708,39.972,55.989,35.655,47.632,43.208,62.01,35.715,48.654,42.456,61.414,36.409,49.878
RFAA,10.588,37.647,7.059,9.412,12.941,36.471,11.765,32.941,12.953,30.084,4.178,7.103,13.37,31.476,12.117,27.019,14.357,32.171,5.938,10.49,14.894,32.374,14.13,30.151
SurfDock,76.471,91.765,52.941,62.353,72.941,94.118,69.412,89.412,51.253,77.577,32.591,41.643,52.368,78.412,50.139,74.234,51.29,76.465,32.333,38.316,52.014,77.016,50.423,74.341
TankBind,3.529,56.471,2.353,5.882,18.824,57.647,16.471,32.941,2.786,16.852,1.393,4.178,6.128,19.499,5.014,12.813,3.659,20.866,2.184,4.432,5.892,25.951,5.778,16.156
Uni-Mol,81.176,94.118,77.647,85.882,83.529,94.118,80.0,84.706,44.986,73.677,40.808,60.585,45.265,72.423,39.554,59.192,38.851,69.482,35.648,57.349,39.915,69.237,36.998,58.25
`;

/**
 * Parses CSV text, extracts specified metrics, sorts the data by a chosen metric (descending), and adds ranks.
 *
 * @param {string} textContent - The raw text content of the CSV file.
 * @param {Array<string>} metricsToExtract - An array of metric header names to extract (case-insensitive).
 * @param {string} sortByMetricKey - The key (from metricsToExtract) to sort by (descending).
 *                               This key should directly match one of the strings in metricsToExtract.
 * @returns {Array<object>} An array of objects, sorted by sortByMetricKey (descending).
 * @throws {Error} If headers are missing, CSV format is invalid, etc.
 */
export default function processAndSortCsvGeneral(metricsToExtract, sortByMetricKey) {
  if (!textContent || typeof textContent !== 'string') {
    throw new Error("Invalid input: textContent must be a non-empty string.");
  }
  if (!Array.isArray(metricsToExtract) || metricsToExtract.length === 0) {
    throw new Error("Invalid input: metricsToExtract must be a non-empty array of strings.");
  }
  if (typeof sortByMetricKey !== 'string' || !sortByMetricKey) {
    throw new Error("Invalid input: sortByMetricKey must be a non-empty string.");
  }
  // Ensure sortByMetricKey is one of the metrics the user intends to extract
  if (!metricsToExtract.find(m => m.toLowerCase() === sortByMetricKey.toLowerCase())) {
    throw new Error(`Invalid input: sortByMetricKey "${sortByMetricKey}" must be one of the metrics defined in metricsToExtract (case-insensitive check). metricsToExtract: [${metricsToExtract.join(', ')}]`);
  }

  const dataArray = [];
  const lines = textContent.split(/\r?\n/).filter(line => line.trim() !== '');

  if (lines.length < 2) {
    throw new Error("CSV content is too short. Must include a header and at least one data row.");
  }

  const headerLine = lines[0];
  const csvHeaders = headerLine.split(',').map(h => h.trim());
  const csvHeadersLower = csvHeaders.map(h => h.toLowerCase());

  const modelIndex = csvHeadersLower.indexOf('model');
  if (modelIndex === -1) {
    throw new Error("Required header 'model' not found in CSV.");
  }

  // Store map from the user-provided key (from metricsToExtract) to its actual CSV header and index
  const metricConfigs = {};
  metricsToExtract.forEach(userKey => {
    const userKeyLower = userKey.toLowerCase();
    const index = csvHeadersLower.indexOf(userKeyLower);
    if (index === -1) {
      throw new Error(`Specified metric header "${userKey}" (checking as "${userKeyLower}") not found in CSV headers: ${csvHeaders.join(', ')}`);
    }
    metricConfigs[userKey] = {
        index: index,
        // originalCsvHeader: csvHeaders[index] // if needed elsewhere
    };
  });

  const dataLines = lines.slice(1);

  dataLines.forEach((line, lineIndex) => {
    if (!line.trim()) return;
    const columns = line.split(',').map(c => c.trim());

    if (columns.length !== csvHeaders.length) {
        console.warn(`Skipping row ${lineIndex + 2} due to inconsistent column count. Expected ${csvHeaders.length}, got ${columns.length}. Line: "${line}"`);
        return;
    }

    const modelValue = columns[modelIndex];
    if (!modelValue) {
      console.warn(`Skipping row ${lineIndex + 2} due to empty Model name.`);
      return;
    }

    // This object will store parsed numeric values with keys from metricsToExtract
    // and raw string values with keys like `${metricKey}_raw`
    const rowData = { model: modelValue };

    metricsToExtract.forEach(metricKey => { // metricKey is e.g., 'Astex_rmsd'
      const config = metricConfigs[metricKey];
      const rawValue = columns[config.index];
      const numericValue = parseFloat(rawValue);
      
      // Store the PARSED numeric value using the exact metricKey
      // This is what we will sort on.
      rowData[metricKey] = isNaN(numericValue) ? rawValue : numericValue;
      // Store the RAW string value with a '_raw' suffix.
      // This is what we will display.
      rowData[`${metricKey}_raw`] = rawValue;
    });
    dataArray.push(rowData);
  });

  // Sort the array of processed rowData objects
  const sortedArray = dataArray.sort((a, b) => {
    // IMPORTANT: Access the PARSED numeric value using sortByMetricKey
    // (e.g., a['Astex_pbvalid'] which holds the float, not a['Astex_pbvalid_raw'])
    const valA = a[sortByMetricKey];
    const valB = b[sortByMetricKey];

    const valAIsNum = typeof valA === 'number' && !isNaN(valA);
    const valBIsNum = typeof valB === 'number' && !isNaN(valB);

    if (valAIsNum && valBIsNum) {
      return valB - valA; // Descending for numbers
    } else if (valAIsNum) {
      return -1; // Numbers come before non-numbers
    } else if (valBIsNum) {
      return 1;  // Non-numbers come after numbers
    } else {
      // Optional: if both are strings or NaN, define a fallback sort order
      // e.g., by model name, or maintain original for stability
      // return String(a.model).localeCompare(String(b.model));
      return 0; // Keep relative order for non-numeric items
    }
  });

  // Add rank and prepare final output objects for display
  const rankedArray = sortedArray.map((item, index) => {
    const finalItem = {
      rank: index + 1,
      model: item.model,
      // release_date: 2025,
    };

    // Populate with RAW string values for display, using the original metricKeys
    metricsToExtract.forEach(metricKey => {
      finalItem[metricKey] = item[`${metricKey}_raw`];
    });
    
    return finalItem;
  });

  return rankedArray;
}